import Vue from 'vue';
import { DateTime, Duration, Interval } from 'luxon';

const INTERVAL = 1000;

export const EVENT_COUNTDOWN_START = '_resume.timer';
export const EVENT_COUNTDOWN_PAUSE = '_pause.timer';
export const EVENT_COUNTDOWN_RESET  = '_reset.timer';
export const EVENT_COUNTDOWN_STOP   = '_stop.timer';
export const EVENT_COUNTDOWN_ENDED  = '_end.timer';

function getCurrentDateTime() {
	return DateTime.fromJSDate(new Date);
}

export const CountdownMixin = {
	data: () => ({
		duration: null
	}),
	computed: {
		remaining: ({ duration, format }) => {
			return Duration
				.fromISO(duration)
				.toFormat(format);
		}
	},
	methods: {
		updateDuration() {
			const now = getCurrentDateTime();

			if (this.isoEnd) {
				const end = DateTime.fromISO(this.isoEnd);

				this.end = this.isoEnd;
				this.duration = Interval.fromDateTimes(now, end).toDuration().toISO();
			} else if (this.isoDuration) {
				const duration = Duration.fromISO(this.isoDuration);

				this.end = Interval.after(now, duration).end.toISO();
				this.duration = Duration.fromISO(this.isoDuration);
			}
		},
		initCountdown() {
			let timer;
			let pausedAt;

			const initTimer = setInterval.bind(null, () => {
				const end = DateTime.fromISO(this.end);
				const duration = Duration.fromISO(this.duration).minus(INTERVAL);
				const interval = Interval.before(end, duration);

				if (interval.isValid)
					this.duration = duration.toISO();
				else {
					clearInterval(timer);
					this.$emit(EVENT_COUNTDOWN_ENDED);
				}
			}, INTERVAL);

			timer = initTimer();

			this.$on(EVENT_COUNTDOWN_START, () => {
				if (pausedAt) {
					const duration = Duration.fromISO(this.duration);
					const interval = Interval.after(pausedAt, duration);
					const now = getCurrentDateTime();

					if (interval.contains(now)) {
						this.duration = interval.splitAt(now)[1].toDuration().toISO();
					} else
						this.updateDuration();

					pausedAt = null;
				}

				timer = initTimer();
			});

			this.$on(EVENT_COUNTDOWN_PAUSE, () => {
				clearInterval(timer);
				pausedAt = getCurrentDateTime();
			});

			this.$on(EVENT_COUNTDOWN_RESET, () => {
				this.updateDuration();
			});

			this.$on(EVENT_COUNTDOWN_STOP, () => {
				this.$emit(EVENT_COUNTDOWN_PAUSE);
				this.$emit(EVENT_COUNTDOWN_RESET);
			});

			this.$once('beforeDestroy', () => clearInterval(timer));
		}
	},
	created: function() {
		this.updateDuration();
	},
	beforeMount: function() {
		this.initCountdown();
	},
	beforeDestroy: function() {
		this.$emit('beforeDestroy');
	},
	render: function(h) {
		return (
			<span>
				{ this.remaining }
			</span>
		);
	}
}

export const Countdown = Vue.extend({
	mixins: [ CountdownMixin ],
	props: ['isoEnd', 'isoDuration', 'format']
});
